import React, { Component } from 'react'
import Modal from '../../Modal'
import TextColourPicker from '../../../toolbar/text/ColorPicker'

import IconClose from '../../../../components/icons/toolbar/menu/text/modal/Close'
import IconAlpha from '../../../../components/icons/toolbar/menu/text/modal/Alpha'
import IconSelect from '../../../../components/icons/toolbar/menu/text/modal/Select'

import Color from '../../../../../utils/Color'
export default class ColourPicker extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: props.show,
      activeId: props.activeId,
      title: props.title,
      color: props.color
        ? Color.rgbaToHsla(props.color)
        : {
            h: 180,
            s: 100,
            l: 50,
            a: 1,
          },
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps
  }

  render() {
    let { title, activeId } = this.state

    if (!activeId) {
      activeId = 1
    }

    return (
      <Modal
        className="p-colour color-picker p-btm"
        show={this.state.show}
        onHide={() => {
          this.props.onHide()
        }}
      >
        <>
          {title}
          <div className="">
            <TextColourPicker
              color={this.state.color}
              onColorUpdated={(color) => {
                this.setState({ color })
              }}
            />
            <div className="row gx-5 align-items-center justify-content-between icons">
              <div className="col-auto">
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    this.props.onHide()
                  }}
                >
                  <IconClose />
                </a>
              </div>

              <div className="col-auto">
                <a
                  href="javascript:void(0)"
                  onClick={() => {
                    this.props.onUpdated(Color.hslaToRgba(this.state.color))
                    this.props.onHide()
                  }}
                >
                  <IconSelect />
                </a>
              </div>
            </div>
          </div>
        </>
      </Modal>
    )
  }
}
